import { render, staticRenderFns } from "./ChangeStatusTicket.vue?vue&type=template&id=60e01414&scoped=true"
import script from "./ChangeStatusTicket.vue?vue&type=script&lang=js"
export * from "./ChangeStatusTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e01414",
  null
  
)

export default component.exports